export default {
    "street": {
        "title": "Arruamento",
        "modal_title": "@:street.title: Adicionar | @:street.title: {name}",
        "model": {
            "id": "Código",
            "designation": "Designação",
            "dicofre": "Freguesia",
            "dicofre_old": "Freguesia Antiga",
            "place": "Localidade",
            "street_state_type": "Estado",
            "street_type": "Tipo",
            "folder_cm": "Número Pasta",
            "code_cm": "Cdg. Arquivo",
            "street_preposition_type": "Preposição",
            "name": "Nome",
            "street_begin": "Início",
            "street_end": "Fim",
            "pickup_at": "Data Levantamento",
            "deliberation_at": "Data Deliberação",
            "insertion_at": "Data Inserção",
            "cancellation_at": "Data Anulação",
            "deliberation_proposal": "Nº Prop. Deliberação",
            "deliberation_proposal_file": "Prop. Deliberação",
            "notice_file": "Edital",
            "curriculum_file": "Curriculum",
            "synopsis": "Sinopse",
            "obs": "Observações"
        },
        "actions": {
            "view-form": {
                "title": "Formulário",
                "help": null
            },
            "view-map": {
                "title": "Mapa",
                "help": null
            },
            "view-deliberation-proposal-file": {
                "title": "Visualizar Proposta Deliberação",
                "help": null
            },
            "view-notice-file": {
                "title": "Visualizar Edital",
                "help": null
            },
            "view-curriculum-file": {
                "title": "Visualizar Curriculum",
                "help": null
            },
            "export": {
                "title": "Ficha Digital",
                "help": null
            }
        },
        "msg": {
            "confirm-delete": "Deseja eliminar o arruamento <strong class='font-weight-bold'>{code}</strong>?",
            "export": {
                "confirm": "Deseja gerar a ficha digital?",
                "processing": "A gerar a ficha digital...",
                "processed": "Ficha digital gerada"
            }
        }
    },
    "street_search": {
        "titles": "Arruamentos",
        "label": "Arruamentos",
        "model": {
            "id": "@:street.model.id",
            "designation": "@:street.model.designation",
            "dicofre_old": "@:street.model.dicofre_old",
            "place": "@:street.model.place"
        },
        "form": {
            "no_geom": "Arruamentos não georreferenciados",
            "code": "@:street.model.id",
            "parishes": "@:street.model.dicofre",
            "parishes_old": "@:street.model.dicofre_old",
            "place": "@:street.model.place",
            "designation": "@:street.model.designation"
        },
        "list": {
            "actions": {
                "create": {
                    "title": "Criar Arruamento",
                    "help": null,
                },
                "clear": {
                    "title": "Limpar pesquisa",
                    "help": null,
                },
                "search": {
                    "title": "Pesquisar",
                    "help": null,
                },
                "view-data": {
                    "title": "Consultar Informação",
                    "help": null,
                },
                "view-on-map": {
                    "title": "Visualizar no mapa",
                    "help": null,
                },
                "appy-on-map": {
                    "title": "Aplicar no mapa",
                    "help": null,
                },
                "reset-map": {
                    "title": "Limpar mapa",
                    "help": null,
                }
            }
        },
        "msg": {
            "export": {
                "confirm": "Pretende {txt}?",
                "processing": "Exportação de <b>{total} elemento</b> em  execução... | Exportação de <b>{total} elementos</b> em  execução...",
                "finished": "Exportação de <b>{total} elemento</b> concluída | Exportação de <b>{total} elementos</b> concluída",
            },
        }
    },
    "house_number": {
        "title": "Nº Polícia",
        "modal_title": "@:house_number.title: Adicionar | @:house_number.title: {number}",
        "model": {
            "street": "Arruamento",
            "number": "Nº Polícia",
            "number_old": "Nº Polícia Anterior",
            "process": "Processo (Nº/Ano)",
            "house_number_type": "Tipo",
            "dicofre": "Freguesia",
            "dicofre_old": "Freguesia Antiga",
            "cp7": "Código Postal",
            "place": "Localidade",
            "toponymic_file": "Ficha toponímica",
            "folder_cm": "Número Pasta",
            "type": "Tipo",
            "classification_type": "Classificação",
            "integration_code": "Código Integração",
            "pickup_at": "Data Levantamento",
            "obs": "Observações",
        },
        "actions": {
            "view-form": {
                "title": "Formulário",
                "help": null
            },
            "view-map": {
                "title": "Mapa",
                "help": null
            },
            "export": {
                "title": "Ficha Digital",
                "help": null
            }
        },
        "msg": {
            "confirm-delete": "Deseja eliminar o nº polícia <strong class='font-weight-bold'>{code}</strong>?",
            "export": {
                "confirm": "Deseja gerar a ficha digital?",
                "processing": "A gerar a ficha digital...",
                "processed": "Ficha digital gerada"
            },
            "error": {
                "no-geom": "É obrigatório definir a posição do nº de polícia."
            }
        }
    },
    "house_number_search": {
        "titles": "Nºs Polícia",
        "label": "Nºs Polícia",
        "model": {
            "street": {
                "id": "@:street.model.id",
                "designation": "Arruamento",
                "dicofre_old": "@:street.model.dicofre_old",
                "place": "@:street.model.place",
                "house_numbers_count": "Total",
            },
            "number": "@:house_number.model.number",
            "number_old": "@:house_number.model.number_old",
            "process": "@:house_number.model.process",
            "house_number_type": "@:house_number.model.house_number_type",
            "cp7": "@:house_number.model.cp7"
        },
        "form": {
            "process": "@:house_number.model.process",
            "parishes": "@:street.model.dicofre",
            "parishes_old": "@:street.model.dicofre_old",
            "place": "@:street.model.place",
            "street": "Designação Rua",
            "code_street": "Código Rua",
            "cp7": "@:house_number.model.cp7"
        },
        "list": {
            "actions": {
                "clear": {
                    "title": "Limpar pesquisa",
                    "help": null,
                },
                "search": {
                    "title": "Pesquisar",
                    "help": null,
                },
                "view-data": {
                    "title": "Consultar Informação",
                    "help": null,
                },
                "view-on-map": {
                    "title": "Visualizar no mapa",
                    "help": null,
                },
                "appy-on-map": {
                    "title": "Aplicar no mapa",
                    "help": null,
                },
                "reset-map": {
                    "title": "Limpar mapa",
                    "help": null,
                },
                "list-house-numbers": {
                    "title": "Nºs Polícia",
                    "help": null,
                },
                "add-house-number": {
                    "title": "Adicionar Nº Polícia",
                    "help": null,
                }
            }
        },
        "msg": {
            "export": {
                "confirm": "Pretende {txt}?",
                "processing": "Exportação de <b>{total} elemento</b> em  execução... | Exportação de <b>{total} elementos</b> em  execução...",
                "finished": "Exportação de <b>{total} elemento</b> concluída | Exportação de <b>{total} elementos</b> concluída",
            },
        }
    }
}
